import {SidebarPageLayout, type SidebarPageLayoutContentProps} from '@github-ui/layout-primitives/SidebarPageLayout'
import type {PropsWithChildren} from 'react'

import styles from './AgentsSpacesPage.module.css'

export function AgentsSpacesPageContent({children, ...props}: PropsWithChildren<SidebarPageLayoutContentProps>) {
  return (
    <SidebarPageLayout.Content as="div" className={styles.content} {...props}>
      <SidebarPageLayout.SidebarTrigger />
      {children}
    </SidebarPageLayout.Content>
  )
}
